const globals = {
  dashboard: {
    title: "Dashboard",
    icon: "IconLayoutDashboardFilled",
  },
  myInvitations: {
    title: "My Invitations",
    icon: "IconCalendarMonth"
  },
  createInvitation: {
    title: "Create Invitation",
    icon: "IconCalendarPlus"
  },
  addons: {
    title: "Addons",
    icon: "IconPackages"
  },
  profile: {
    title: "Profile",
    icon: "IconUserSquareRounded"
  },
  editProfile: {
    title: "Edit Profile",
    icon: "IconUserSquareRounded"
  },
  myStudios: {
    title: "My Studios",
    icon: "IconBuildings"
  },
  addStudio: {
    title: "Add Studio",
    icon: "IconBuildings"
  },
  editStudio: {
    title: "Edit Studio",
    icon: "IconBuildings"
  },
  addService: {
    title: "Add Service",
    icon: "IconBuildings"
  },
  editService: {
    title: "Edit Service",
    icon: "IconBuildings"
  },
  invitationType: {
    title: "Invitation Type",
    icon: "IconCategoryFilled"
  },
  selectTheme: {
    title: "Select Theme",
    icon: "IconPalette"
  },
  wedding: {
    title: "Wedding Invitation",
    icon: "IconGift"
  },
  birthday: {
    title: "Birthday Invitation",
    icon: "IconCake"
  },
  settings: {
    title: "Settings",
    icon: "IconSettings"
  },
  myplan: {
    title: "My Plans",
    icon: "IconIdBadge2"
  },
  myoneqr: {
    title: "My QR Code",
    icon: "IconQrcode"
  },
  mydemos: {
    title: "My Demos",
    icon: "IconVideo"
  },
  createDemo: {
    title: "Create Demo",
    icon: "IconVideoPlus"
  },
  demo: {
    title: "Demo",
    icon: "IconVideoPlus"
  },
  myservices: {
    title: "My Services",
    icon: "IconBuildingStore"
  },
  mygallery: {
    title: "My Gallery",
    icon: "IconVideoPlus"
  },
  createWebsite: {
    title: "My Website",
    icon: "IconWorldWww"
  },
  domains: {
    title: "Domains",
    icon: "IconWorld"
  },
  downloads: {
    title: "Downloads",
    icon: "IconFiles"
  },
  addons: {
    title: "Addons",
    icon: "IconPackages"
  },
};

export default globals;